module.exports = __webpack_public_path__ + "img/settori-attività-emt.fb445024.png";